import React from "react";
import { DashboardWrapper, DashBoardRow, Dashboard, CustomTab, TabView, CustomTabNth } from "./MetricDashboard.styles";
import VCCPView from "./VCCPView";
import { Tabs } from "@vds/tabs";
import CFSTView from "./CFST/CFSTView";

export default function MetricDashboardPage() {
  return (
    <DashboardWrapper>
      <DashBoardRow>
        <Dashboard>Metric Dashboard</Dashboard>
      </DashBoardRow>
      <TabView>
        <Tabs orientation="horizontal" indicatorPosition="bottom" sticky={true} width="100%">
          <CustomTab label="CFST">
            <CFSTView />
          </CustomTab>
          {/* Hiding the Support Case Portal tab for time being, please enable it when needed */}
          <div style={{ display: "none" }}>
            <CustomTabNth label="Support Case Portal">
              <VCCPView />
            </CustomTabNth>
          </div>
        </Tabs>
      </TabView>
    </DashboardWrapper>
  );
}
